import { type LocationObjectType, type Money } from "common/types/mainTypes";
import { GeoErrorsCode } from "./Map/utils";
import { type TimeFormatType } from "./types";
import { TIME_FORMATS } from "./constants";

const checkNotNull = (entry: string | number | null): boolean => entry !== null;

export const getPossibleLocationError = (node: LocationObjectType): string | null => {
  const entries = [node?.street ?? null, node?.postalCode ?? null, node?.city ?? null];

  const entriesFullAddress = [
    node?.street ?? null,
    node?.stateId ?? null,
    node?.postalCode ?? null,
    node?.city ?? null,
    node?.countryId ?? null,
  ];

  const hasSomeBasicAddress = entries.some(checkNotNull);
  const hasSomeFullAddress = entriesFullAddress.some(checkNotNull);

  const hasGeolocation = Boolean(node.latitude && node.longitude);

  if (!hasSomeBasicAddress) {
    if (hasGeolocation && hasSomeFullAddress) {
      // Some address fields and geolocation are present but basic address field are missing
      return GeoErrorsCode.PoorSpecificity;
    }

    if (!hasGeolocation && !hasSomeFullAddress) {
      // No geolocation and address at all
      return GeoErrorsCode.MissingLocation;
    }

    if (!hasGeolocation && hasSomeFullAddress) {
      // No Geolocation but some address field exist (but not basic address field)
      return GeoErrorsCode.GeocodingError;
    }
    // Location entered by hand or at least one basic entry with geolocation
    return null;
  } else if (!hasGeolocation) {
    // Wrong address entered
    return GeoErrorsCode.GeocodingError;
  }
  return null;
};

export const filterDuplicatesById = <T extends { id: string }>(objects: T[]): T[] => {
  const listAsset: Record<string, boolean> = {};
  return objects.filter((o) => {
    if (!listAsset[o.id]) {
      listAsset[o.id] = true;
      return true;
    }
    return false;
  });
};

export const setGpFavicons = (
  faviconUrl16px: string | null | undefined,
  faviconUrl32px: string | null | undefined,
): void => {
  const favicon = document.getElementById("favicon") as HTMLAnchorElement | null;
  if (favicon) {
    favicon.href = faviconUrl16px || "/static/icons/favicon.ico";
  }
  const favicon16 = document.getElementById("favicon16") as HTMLAnchorElement | null;
  if (favicon16) {
    favicon16.href = faviconUrl16px || "/static/icons/favicon-16x16.png";
  }
  const favicon32 = document.getElementById("favicon32") as HTMLAnchorElement | null;
  if (favicon32) {
    favicon32.href = faviconUrl32px || "/static/icons/favicon-32x32.png";
  }
};

export const hasMoney = (money: Money | null) => (money?.amount ?? -1) > 0;

export const getTimeFormatStrings = (timeFormat: TimeFormatType): string => {
  if (timeFormat) {
    return TIME_FORMATS[timeFormat];
  }
  // Return default 12-hour time format
  return TIME_FORMATS["12-hour"];
};
